import React, { useState } from "react";
import { selectionpng } from "../../../assets";

interface ExistsOwnMemberModelProps {
	onClose: () => void;
	dependentData: any;
}

const ExistsDependentModel: React.FC<ExistsOwnMemberModelProps> = ({ onClose, dependentData }) => {
	return (
		<div
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: "rgba(0, 0, 0, 0.5)",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				zIndex: 1000
			}}
		>
			<div
				style={{
					backgroundColor: "white",
					padding: "10px",
					borderRadius: "8px",
					boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
					maxWidth: "450px",
					width: "100%",
					textAlign: "center"
				}}
			>
				<img
					src={selectionpng}
					alt="Duplicate SSN"
					style={{
						width: "80px",
						height: "80px"
					}}
				/>
				<h2
					style={{
						marginBottom: "20px",
						fontSize: "1.75rem",
						color: "#333",
						fontWeight: "600"
					}}
				>
					Attention
				</h2>
				<p
					style={{
						marginBottom: "25px",
						fontSize: "1rem",
						color: "#495057",
						lineHeight: "1.5"
					}}
				>
					Please Deselect the dependent{" "}
					<span
						style={{
							backgroundColor: "yellow",
							fontWeight: "bold"
						}}
					>
						{dependentData.first_name}
					</span>{" "}
					<span
						style={{
							backgroundColor: "yellow",
							fontWeight: "bold"
						}}
					>
						{dependentData.last_name}
					</span>{" "}
				</p>
				<button
					style={{
						backgroundColor: "black",
						color: "white",
						border: "none",
						padding: "12px 24px",
						borderRadius: "5px",
						cursor: "pointer",
						fontSize: "1rem",
						transition: "background-color 0.3s ease",
						fontWeight: "500"
					}}
					onClick={onClose}
				>
					Close
				</button>
			</div>
		</div>
	);
};

export default ExistsDependentModel;
